import { ACTUALIZAR_LIST_ATRIBUTOS_FICHA, AGREGAR_ATRIBUTOS_FICHA, MODIFICAR_ATRIBUTOS_FICHA } from "./atributosFichaTecActions";


  const atributosFichaTecReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_ATRIBUTOS_FICHA: {
            return {
                ...state,
                atributosList: action.payload
            }
        };

        case AGREGAR_ATRIBUTOS_FICHA:{
            return {
                 ...state,
                 atributosList: [action.payload, ...state.atributosList]
             }
         };

         case MODIFICAR_ATRIBUTOS_FICHA: {
            return {
                ...state,
                atributosList: state.atributosList.map((g) => g._id === action.payload._id ? action.payload : g)
            }
        };
        
        default:
            return state;

    }
  }

  export default atributosFichaTecReducer;